import React from 'react'
import styled, { keyframes } from 'styled-components'

const scrollAnimation = keyframes`
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
    transform: translateY(20px);
  }
`

const entry = keyframes`
  0% {
    opacity: 0;
    transform: translateY(60%);
  }
  100% {
    opacity: 1;
    transform: translateY(0%);
  }
`

const Wrapper = styled.div`
  position: relative;
  width: 20px;
  height: 35px;
  border: 2px solid #fff;
  border-radius: 25px;
  animation: ${entry} 400ms 1s both;

  &:before {
    display: block;
    content: '';
    position: absolute;
    top: 8px;
    left: 50%;
    width: 4px;
    height: 4px;
    background: #fff;
    margin-left: -2px;
    border-radius: 3px;
    animation-duration: 1.5s;
    animation-iteration-count: infinite;
    animation-name: ${scrollAnimation};
  }
`

const ScrollIndicator = props => <Wrapper {...props} />

export default ScrollIndicator



// WEBPACK FOOTER //
// ./src/ui/components/generic/ScrollIndicator.js